import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { HdsSeparator } from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';

/**
 *
 * `Compliance::Footer` renders the footer links on the compliance pages.
 *
 *
 * ```
 * <Compliance::Footer />
 * ```
 *
 * @class ComplianceFooter
 *
 */
export default class ComplianceFooter extends Component {
  @service systemStatus;

  get statusPageUrl() {
    return this.systemStatus.statusPageUrl;
  }
  <template>
    <footer class="compliance__footer" data-test-page-sign-in-main-footer>
      <HdsSeparator />

      <Flex
        @alignItems="flex-start"
        @basis="content"
        @direction="row"
        @gap="lg"
        @justifyContent="flex-start"
        @grow={{0}}
        @wrap={{true}}
      >
        <a
          href="https://www.hashicorp.com/privacy"
          rel="noreferrer noopener"
          target="_blank"
          data-test-link-privacy
        >
          {{t "components.layout.footer.privacy-long"}}
        </a>
        <a
          href="{{this.statusPageUrl}}"
          rel="noreferrer noopener"
          target="_blank"
          data-test-link-status-page
        >
          {{t "components.hcp.status-page-link"}}
        </a>
      </Flex>
    </footer>
  </template>
}
